"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarqueePanel = void 0;
exports.default = FullWidthMarqueePanel;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _marqueeAttributedImage = _interopRequireDefault(require("./marquee-attributed-image.js"));
var _card = _interopRequireDefault(require("../../../elements/other/card"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _index = _interopRequireDefault(require("../../../elements/other/form-group/index.js"));
var _index2 = _interopRequireDefault(require("../../../experiments/marketing-lead-form/index.js"));
var _leadGenForm = _interopRequireDefault(require("../../../elements/other/lead-gen-form-modal/lead-gen-form.js"));
var _leadGenSuccess = _interopRequireDefault(require("../../../elements/other/lead-gen-form-modal/lead-gen-success.js"));
var _index3 = require("../../../elements/other/lead-gen-form-modal/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MarqueePanel = exports.MarqueePanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarqueePanel",
  class: "pl-mwq1wo5",
  vars: {
    "mwq1wo5-0": [({
      textAlign
    }) => textAlign === 'center' ? 'center' : 'space-between'],
    "mwq1wo5-1": [({
      textAlign
    }) => textAlign === 'center' ? 'center' : 'stretch'],
    "mwq1wo5-4": [({
      textAlign
    }) => textAlign],
    "mwq1wo5-5": [({
      landscapeBackgroundImage
    }) => landscapeBackgroundImage ? `url(${landscapeBackgroundImage})` : 'initial']
  }
});
const PanelSuccess = /*#__PURE__*/(0, _react2.styled)(_leadGenSuccess.default)({
  name: "PanelSuccess",
  class: "pl-p1dcmp6y"
});
const PrimaryPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PrimaryPanel",
  class: "pl-p1vbjaqx",
  vars: {
    "p1vbjaqx-0": [({
      textAlign
    }) => `${textAlign}`],
    "p1vbjaqx-2": [({
      layout
    }) => layout === 'marketingLeadForm' ? '100%' : 'min(26.3rem,52vw)'],
    "p1vbjaqx-4": [({
      textAlign
    }) => textAlign === 'center' ? '45rem' : '34.25rem'],
    "p1vbjaqx-7": [({
      textAlign
    }) => textAlign === 'center' ? '53rem' : '34.25rem']
  }
});

/**
 * Render Full Width Marquee Panel block.
 *
 * @param {object} props - Props
 * @param {string} props.className - Class names
 * @param {object} props.style - Style props
 * @param {object} props.backgroundImages Object of background images for all breakpoints.
 * @param {React.ReactElement} props.attributedImage Attributed Image component
 * @param {string} props.textAlign Align start, center, end or inherit
 * @returns {React.ReactElement} Large Marquee Panel component
 * @param {Object|React.ReactElement} props.priceLockup  Price Lockup component or React node
 * @public
 */
function FullWidthMarqueePanel({
  className = '',
  style,
  backgroundImages,
  attributedImage,
  textAlign,
  primaryPanel,
  secondaryPanel,
  layout,
  priceLockup
}) {
  const [successModal, setSuccessModal] = (0, _react.useState)(false);
  const {
    image,
    header,
    closeText,
    subHeading,
    video,
    ctas,
    helpfulLinks
  } = secondaryPanel?.successModal || {};
  const getLeadFilterData = (data, filters = secondaryPanel?.leadFilter) => {
    for (let i = 0; i < filters.length; i++) {
      let isValid = false;
      const {
        fieldName,
        regexp,
        options
      } = filters[i];
      if (options) {
        isValid = options.some(option => option.value === data[fieldName]);
      } else if (regexp) {
        isValid = new RegExp(regexp).test(data[fieldName]);
      }
      if (isValid) {
        return filters[i];
      }
    }
  };
  const handleSuccess = data => {
    const leadFilterData = getLeadFilterData(data) || {};
    setSuccessModal(leadFilterData.successModal || secondaryPanel.successModal);
  };
  function handleError() {
    setSuccessModal(false);
  }
  function handleSubmit(data) {
    const {
      annualsales
    } = data;
    const leadFilterData = getLeadFilterData(data);
    const annualSalesTracking = secondaryPanel.annualSalesTracking || [];
    const trackingValues = annualSalesTracking?.map(item => item.value) || [];
    if (secondaryPanel?.leadType?.leadType === 'Payments' && trackingValues.includes(annualsales)) {
      (0, _index3.pushToGoogleAnalytics)('event', 'conversion', {
        send_to: 'AW-1069554140/NobECODn7agDENyzgP4D'
      });
    }
    return {
      sendRequest: (leadFilterData && Boolean(leadFilterData.sendRequest)) ?? true
    };
  }
  const renderSecondaryPanelBasedOnLayout = () => {
    if (layout === 'racForm') {
      return successModal ? /*#__PURE__*/_react.default.createElement(PanelSuccess, {
        leadType: secondaryPanel?.leadType,
        payMeNumber: secondaryPanel.payMeNumber || '',
        modalHeader: secondaryPanel.modalHeader,
        successImage: image,
        successHeader: header,
        helpfulLinks: helpfulLinks,
        successCloseText: closeText,
        successSubHeading: subHeading,
        successVideo: video,
        ctas: ctas
      }) : /*#__PURE__*/_react.default.createElement(_leadGenForm.default, (0, _extends2.default)({}, secondaryPanel, {
        onError: handleError,
        onSubmit: handleSubmit,
        onSuccess: handleSuccess
      }));
    } else if (layout === 'marketingLeadForm') {
      return /*#__PURE__*/_react.default.createElement(_index2.default, secondaryPanel);
    }
    return /*#__PURE__*/_react.default.createElement(_index.default, secondaryPanel);
  };
  return /*#__PURE__*/_react.default.createElement(MarqueePanel, (0, _extends2.default)({
    textAlign: textAlign
  }, backgroundImages, {
    style: style,
    className: className,
    "data-cy": "full-width-marquee-panel"
  }), primaryPanel && /*#__PURE__*/_react.default.createElement(PrimaryPanel, {
    className: 'primary-panel',
    textAlign: textAlign,
    layout: layout
  }, /*#__PURE__*/_react.default.createElement(_card.default, (0, _extends2.default)({
    textAlign: textAlign,
    padding: "none",
    indented: true
  }, primaryPanel, {
    priceLockup: priceLockup
  }))), secondaryPanel && renderSecondaryPanelBasedOnLayout(), attributedImage && /*#__PURE__*/_react.default.createElement(_marqueeAttributedImage.default, attributedImage));
}
FullWidthMarqueePanel.propTypes = {
  backgroundImages: _propTypes.default.shape({
    portraitBackgroundImage: _propTypes.default.string,
    landscapeBackgroundImage: _propTypes.default.string
  }),
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  primaryPanel: _propTypes.default.shape({
    ..._card.default.propTypes
  }),
  secondaryPanel: _propTypes.default.object,
  layout: _propTypes.default.oneOf(['default', 'centered', 'SSO', 'formgroup', 'racForm', 'marketingLeadForm']),
  attributedImage: _propTypes.default.shape({
    ..._marqueeAttributedImage.default.propTypes
  }),
  priceLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node])
};